/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import Badges from "../components/Badges";
import {
  getAllRideByAdmin,
  updateRideFollowUpCall,
  adminConfirmTripCompleted,
} from "../api/rideApi";
import { FiRefreshCw, FiPhoneCall, FiCheckCircle, FiAlertTriangle } from "react-icons/fi";
import AccessControl from "../components/AccessControl";
const statuses = ["All", "Completed", "Ongoing", "Pending", "Cancelled"];

const shortenAddress = (address, maxLength = 40) => {
  if (!address) return "–";
  return address.length > maxLength
    ? address.slice(0, maxLength) + "…"
    : address;
};

const DATE_FILTERS = ["All", "Today", "Yesterday", "This Month", "Custom"];
const DATE_FILTER_PARAM = {
  All: "all",
  Today: "today",
  Yesterday: "yesterday",
  "This Month": "month",
  Custom: "custom",
};

export default function Bookings() {
  const [activeFilter, setActiveFilter] = useState("All");
  const [rides, setRides] = useState([]);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [limit] = useState(10);
  const [total, setTotal] = useState(0);

  // ── Date filter state ───────────────────────────────────────────────
  const [dateFilter, setDateFilter] = useState("All");
  const [customFrom, setCustomFrom] = useState(""); // yyyy-mm-dd, input value
  const [customTo, setCustomTo] = useState("");
  // Only the *applied* custom range triggers a fetch — typing in the date
  // inputs shouldn't refetch on every keystroke, just on "Apply".
  const [appliedCustomRange, setAppliedCustomRange] = useState({
    from: "",
    to: "",
  });

  // ── Follow-up call modal state ────────────────────────────────────────
  const [followUpRide, setFollowUpRide] = useState(null); // ride currently open in modal
  // Admin "confirm trip completed" — for rides stuck in waiting_for_summary
  const [confirmRide, setConfirmRide] = useState(null);
  const [confirmPaymentMode, setConfirmPaymentMode] = useState("cash");
  const [confirmSubmitting, setConfirmSubmitting] = useState(false);
  const [confirmError, setConfirmError] = useState("");
  const [reachedSafely, setReachedSafely] = useState(null); // true | false | null
  const [appUseful, setAppUseful] = useState(null);
  const [hasIssue, setHasIssue] = useState(null);
  const [issueDetails, setIssueDetails] = useState("");
  const [driverBroughtSafely, setDriverBroughtSafely] = useState(null);
  const [followUpNotes, setFollowUpNotes] = useState("");
  const [followUpSubmitting, setFollowUpSubmitting] = useState(false);
  const [followUpError, setFollowUpError] = useState("");

  const openFollowUpModal = (ride) => {
    setFollowUpRide(ride);
    // Pre-fill with any previously logged answers so a call can be edited
    setReachedSafely(ride.followUp?.reachedSafely ?? null);
    setAppUseful(ride.followUp?.appUseful ?? null);
    setHasIssue(ride.followUp?.hasIssue ?? null);
    setIssueDetails(ride.followUp?.issueDetails ?? "");
    setDriverBroughtSafely(ride.followUp?.driverBroughtSafely ?? null);
    setFollowUpNotes(ride.followUp?.notes ?? "");
    setFollowUpError("");
  };

  const closeFollowUpModal = () => {
    setFollowUpRide(null);
    setFollowUpError("");
  };

  const openConfirmModal = (ride) => {
    setConfirmRide(ride);
    setConfirmPaymentMode("cash");
    setConfirmError("");
  };
  const closeConfirmModal = () => {
    setConfirmRide(null);
    setConfirmError("");
  };
  const handleConfirmTripCompleted = async () => {
    setConfirmSubmitting(true);
    setConfirmError("");
    const res = await adminConfirmTripCompleted({
      rideId: confirmRide.rideId,
      paymentMode: confirmPaymentMode,
    });
    setConfirmSubmitting(false);
    if (res.success) {
      setRides((prev) =>
        prev.map((r) =>
          r.rideId === confirmRide.rideId ? { ...r, ...res.ride } : r,
        ),
      );
      closeConfirmModal();
    } else {
      setConfirmError(res.error || "Could not confirm this ride. Please try again.");
    }
  };

  const handleSubmitFollowUp = async () => {
    if (reachedSafely === null || appUseful === null || hasIssue === null) {
      setFollowUpError("Please answer all questions before saving.");
      return;
    }
    if (hasIssue && !issueDetails.trim()) {
      setFollowUpError("Please describe the issue the passenger mentioned.");
      return;
    }
    if (hasIssue && driverBroughtSafely === null) {
      setFollowUpError(
        "Please confirm whether the driver still handled it / brought the passenger back safely.",
      );
      return;
    }

    setFollowUpSubmitting(true);
    setFollowUpError("");
    const res = await updateRideFollowUpCall({
      rideId: followUpRide.rideId,
      reachedSafely,
      appUseful,
      hasIssue,
      issueDetails: hasIssue ? issueDetails.trim() : null,
      driverBroughtSafely: hasIssue ? driverBroughtSafely : null,
      notes: followUpNotes.trim() || null,
    });
    setFollowUpSubmitting(false);

    if (res.success) {
      // Update this ride in local state so the table + badge refresh
      // immediately without needing a full refetch
      setRides((prev) =>
        prev.map((r) =>
          r.rideId === followUpRide.rideId
            ? { ...r, followUp: res.ride.followUp }
            : r,
        ),
      );
      closeFollowUpModal();
    } else {
      setFollowUpError(
        res.error || "Failed to save follow-up call. Try again.",
      );
    }
  };

  // 🔁 Fetch rides from backend
  const fetchRides = async () => {
    setLoading(true);
    const payload = {
      n_limit: limit,
      n_page: page,
      c_search_term: search,
      date_filter: DATE_FILTER_PARAM[dateFilter] || "all",
      ...(dateFilter === "Custom"
        ? { from_date: appliedCustomRange.from, to_date: appliedCustomRange.to }
        : {}),
    };
    const res = await getAllRideByAdmin(payload);
    if (res.success) {
      setRides(res.rides);
      setTotal(res.total);
    }
    setLoading(false);
  };


  useEffect(() => {
    console.log(followUpRide,"<<< followup rides")
  }, [followUpRide]);

  useEffect(() => {
    // Custom range needs both dates picked and "Apply" pressed before we
    // fetch — otherwise every keystroke in the date inputs would refetch.
    if (
      dateFilter === "Custom" &&
      (!appliedCustomRange.from || !appliedCustomRange.to)
    ) {
      return;
    }
    fetchRides();
  }, [search, page, dateFilter, appliedCustomRange]);

  const selectDateFilter = (f) => {
    setPage(1);
    setDateFilter(f);
  };

  const applyCustomRange = () => {
    if (!customFrom || !customTo) return;
    setPage(1);
    setAppliedCustomRange({ from: customFrom, to: customTo });
  };

  // 🔎 Filter rides by status + search
  const filtered = rides.filter((r) => {
    const statusMap = {
      trip_completed: "Completed",
      trip_started: "Ongoing",
      requested: "Pending",
      canceled: "Cancelled",
      waiting_for_summary: "Awaiting Confirmation",
    };
    const rideStatus = statusMap[r.status] || r.status;

    const matchStatus = activeFilter === "All" || rideStatus === activeFilter;
    const matchSearch =
      search === "" ||
      r.passenger?.name?.toLowerCase().includes(search.toLowerCase()) ||
      r.driver?.name?.toLowerCase().includes(search.toLowerCase()) ||
      r.rideId?.toLowerCase().includes(search.toLowerCase());

    return matchStatus && matchSearch;
  });

  return (
    <div>
      <AccessControl
        allowedRoles={["SUPERADMIN", "ADMIN", "HR", "NSM", "RSM", "ASM", "TSO"]}
        redirectTo="/404"
      />
      {/* Summary stats */}
      <div className="stat-grid section">
        <div className="stat-card">
          <div className="stat-label">Total</div>
          <div className="stat-value">{total}</div>
        </div>
        <div className="stat-card">
          <div className="stat-label">Completed</div>
          <div className="stat-value" style={{ color: "#0F6E56" }}>
            {rides.filter((r) => r.status === "trip_completed").length}
          </div>
        </div>
        <div className="stat-card">
          <div className="stat-label">Ongoing</div>
          <div className="stat-value" style={{ color: "#185FA5" }}>
            {rides.filter((r) => r.status === "trip_started").length}
          </div>
        </div>
        <div className="stat-card">
          <div className="stat-label">Cancelled</div>
          <div className="stat-value" style={{ color: "#A32D2D" }}>
            {rides.filter((r) => r.status === "canceled").length}
          </div>
        </div>
      </div>

      <div className="card">
        {/* Filters + Search */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: 16,
            flexWrap: "wrap",
            gap: 10,
          }}
        >
          <div className="filter-tabs" style={{ margin: 0 }}>
            {statuses.map((s) => (
              <button
                key={s}
                className={`filter-tab ${activeFilter === s ? "active" : ""}`}
                onClick={() => setActiveFilter(s)}
              >
                {s}
              </button>
            ))}
          </div>
          <div className="search-wrap">
            <svg
              className="search-icon"
              viewBox="0 0 24 24"
              fill="currentColor"
            >
              <path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z" />
            </svg>
            <input
              className="search-input"
              placeholder="Search bookings..."
              value={search}
              onChange={(e) => {
                setPage(1); // reset to first page when search changes
                setSearch(e.target.value);
              }}
            />
          </div>
          <div>
            <button onClick={fetchRides} className="btn-outline-green btn-sm">
              <FiRefreshCw
                style={{
                  marginRight: 6,
                  animation: loading ? "spin 1s linear infinite" : "none",
                }}
              />
            </button>
          </div>
        </div>

        {/* Date filter */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            flexWrap: "wrap",
            gap: 10,
            marginBottom: 16,
          }}
        >
          <div className="filter-tabs" style={{ margin: 0 }}>
            {DATE_FILTERS.map((f) => (
              <button
                key={f}
                className={`filter-tab ${dateFilter === f ? "active" : ""}`}
                onClick={() => selectDateFilter(f)}
              >
                {f}
              </button>
            ))}
          </div>

          {dateFilter === "Custom" && (
            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
              <input
                type="date"
                value={customFrom}
                max={customTo || undefined}
                onChange={(e) => setCustomFrom(e.target.value)}
                style={{
                  border: "1px solid #ddd",
                  borderRadius: 6,
                  padding: "6px 8px",
                  fontSize: 12,
                }}
              />
              <span style={{ color: "#888", fontSize: 12 }}>to</span>
              <input
                type="date"
                value={customTo}
                min={customFrom || undefined}
                onChange={(e) => setCustomTo(e.target.value)}
                style={{
                  border: "1px solid #ddd",
                  borderRadius: 6,
                  padding: "6px 8px",
                  fontSize: 12,
                }}
              />
              <button
                onClick={applyCustomRange}
                disabled={!customFrom || !customTo}
                className="btn-outline-green btn-sm"
              >
                Apply
              </button>
            </div>
          )}
        </div>

        {/* Table */}
        <div className="table-wrap">
          <table>
            <thead>
              <tr>
                <th>Booking ID</th>
                <th>Customer</th>
                <th>Driver</th>
                <th>Vehicle No</th>
                <th>Pickup</th>
                <th>Drop</th>
                <th>Date</th>
                <th>Time</th>
                <th>Fare</th>
                <th>Status</th>
                <th>Follow-up Call</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td
                    colSpan={10}
                    style={{ textAlign: "center", padding: "30px" }}
                  >
                    Loading...
                  </td>
                </tr>
              ) : filtered.length === 0 ? (
                <tr>
                  <td
                    colSpan={10}
                    style={{
                      textAlign: "center",
                      padding: "30px",
                      color: "#888",
                    }}
                  >
                    No bookings found
                  </td>
                </tr>
              ) : (
                filtered.map((r) => {
                  const statusMap = {
                    trip_completed: "Completed",
                    trip_started: "Ongoing",
                    requested: "Pending",
                    canceled: "Cancelled",
                    waiting_for_summary: "Awaiting Confirmation",
                  };
                  const rideStatus = statusMap[r.status] || r.status;

                  return (
                    <tr key={r._id}>
                      <td style={{ fontWeight: 600, color: "#0F6E56" }}>
                        {r.rideId}
                      </td>
                      <td>{r.passenger?.name || "–"}</td>
                      <td style={{ color: r.driver?.name ? "#333" : "#ccc" }}>
                        {r.driver?.name || "–"}
                      </td>
                      <td>{r.driver?.vehicleNumber || "–"}</td>
                      <td
                        style={{
                          maxWidth: 200,
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                        }}
                        title={r.pickupLocation?.address}
                      >
                        {shortenAddress(r.pickupLocation?.address)}
                      </td>
                      <td
                        style={{
                          maxWidth: 200,
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                        }}
                        title={r.dropLocation?.address}
                      >
                        {shortenAddress(r.dropLocation?.address)}
                      </td>
                      <td style={{ color: "#888" }}>
                        {new Date(r.createdAt).toLocaleDateString()}
                      </td>
                      <td style={{ color: "#888" }}>
                        {new Date(r.createdAt).toLocaleTimeString()}
                      </td>
                      <td style={{ fontWeight: 600 }}>₹{r.fare?.toFixed(2)}</td>
                      <td>
                        <Badges status={rideStatus} />
                      </td>
                      <td>
                        {r.status === "waiting_for_summary" ? (
                          <button
                            onClick={() => openConfirmModal(r)}
                            title="Passenger never submitted payment/rating — confirm the trip manually"
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: 6,
                              background: "#B45309",
                              border: "none",
                              color: "#fff",
                              borderRadius: 6,
                              padding: "4px 8px",
                              fontSize: 12,
                              cursor: "pointer",
                            }}
                          >
                            <FiAlertTriangle /> Confirm Trip
                          </button>
                        ) : r.status !== "trip_completed" ? (
                          <span style={{ color: "#ccc", fontSize: 12 }}>–</span>
                        ) : r.followUp?.isCalled ? (
                          <button
                            onClick={() => openFollowUpModal(r)}
                            title={`Called by ${r.followUp.calledByName || r.followUp.calledByRole || "staff"} on ${
                              r.followUp.calledAt
                                ? new Date(r.followUp.calledAt).toLocaleString()
                                : ""
                            }`}
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: 6,
                              background: "none",
                              border: "1px solid #0F6E56",
                              color: "#0F6E56",
                              borderRadius: 6,
                              padding: "4px 8px",
                              fontSize: 12,
                              cursor: "pointer",
                            }}
                          >
                            <FiCheckCircle /> Called
                            {r.followUp.hasIssue && (
                              <span
                                style={{
                                  marginLeft: 4,
                                  color: "#A32D2D",
                                  fontWeight: 600,
                                }}
                              >
                                ⚠ Issue
                              </span>
                            )}
                          </button>
                        ) : (
                          <button
                            onClick={() => openFollowUpModal(r)}
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: 6,
                              background: "#0F6E56",
                              border: "none",
                              color: "#fff",
                              borderRadius: 6,
                              padding: "4px 8px",
                              fontSize: 12,
                              cursor: "pointer",
                            }}
                          >
                            <FiPhoneCall /> Log Call
                          </button>
                        )}
                      </td>
                    </tr>
                  );
                })
              )}
            </tbody>
          </table>
        </div>

        {/* Pagination */}
        <div
          style={{
            marginTop: 14,
            padding: "12px 0 0",
            borderTop: "1px solid #f0f0ec",
            fontSize: 12,
            color: "#888",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <span>
            Showing {filtered.length} of {total} bookings
          </span>
          <div style={{ display: "flex", gap: 8 }}>
            <button disabled={page === 1} onClick={() => setPage((p) => p - 1)}>
              Prev
            </button>
            <span>Page {page}</span>
            <button
              disabled={page * limit >= total}
              onClick={() => setPage((p) => p + 1)}
            >
              Next
            </button>
          </div>
        </div>
      </div>

      {/* ── Confirm Trip Completed Modal ────────────────────────────── */}
      {confirmRide && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(0,0,0,0.45)",
            zIndex: 999,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: 16,
          }}
          onClick={closeConfirmModal}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              background: "#fff",
              borderRadius: 12,
              width: 420,
              maxWidth: "100%",
              padding: 20,
            }}
          >
            <h3 style={{ margin: "0 0 4px" }}>Confirm Trip Completed</h3>
            <p style={{ fontSize: 13, color: "#666", marginTop: 0 }}>
              {confirmRide.rideId} ·{" "}
              {confirmRide.passenger?.name || "Passenger"}
              {confirmRide.driver?.name ? ` with ${confirmRide.driver.name}` : ""}
            </p>

            <div
              style={{
                background: "#FFFBEB",
                border: "1px solid #FDE68A",
                borderRadius: 8,
                padding: 10,
                fontSize: 12,
                color: "#92400E",
                marginBottom: 16,
                display: "flex",
                gap: 8,
              }}
            >
              <FiAlertTriangle style={{ flexShrink: 0, marginTop: 2 }} />
              <span>
                The passenger never submitted payment/rating for this ride, so
                it's been stuck waiting. Confirm with the driver how the fare
                (₹{confirmRide.fare?.toFixed(2)}) was actually paid before closing this out —
                this cannot be undone.
              </span>
            </div>

            <label style={{ fontSize: 12, fontWeight: 600, color: "#333" }}>
              How was this ride paid?
            </label>
            <div style={{ display: "flex", gap: 10, marginTop: 6, marginBottom: 16 }}>
              {[
                { key: "cash", label: "Cash (driver collected directly)" },
                { key: "wallet", label: "Wallet (deduct from passenger)" },
              ].map((opt) => (
                <button
                  key={opt.key}
                  onClick={() => setConfirmPaymentMode(opt.key)}
                  style={{
                    flex: 1,
                    padding: "10px 8px",
                    borderRadius: 8,
                    border:
                      confirmPaymentMode === opt.key
                        ? "2px solid #0F6E56"
                        : "1px solid #ddd",
                    background: confirmPaymentMode === opt.key ? "#ECFDF5" : "#fff",
                    color: confirmPaymentMode === opt.key ? "#0F6E56" : "#555",
                    fontWeight: confirmPaymentMode === opt.key ? 700 : 500,
                    fontSize: 12,
                    cursor: "pointer",
                  }}
                >
                  {opt.label}
                </button>
              ))}
            </div>

            {confirmError && (
              <div style={{ color: "#A32D2D", fontSize: 12, marginBottom: 12 }}>
                {confirmError}
              </div>
            )}

            <div style={{ display: "flex", justifyContent: "flex-end", gap: 10 }}>
              <button
                onClick={closeConfirmModal}
                disabled={confirmSubmitting}
                style={{
                  padding: "8px 16px",
                  borderRadius: 8,
                  border: "1px solid #ddd",
                  background: "#fff",
                  cursor: "pointer",
                }}
              >
                Cancel
              </button>
              <button
                onClick={handleConfirmTripCompleted}
                disabled={confirmSubmitting}
                style={{
                  padding: "8px 16px",
                  borderRadius: 8,
                  border: "none",
                  background: "#0F6E56",
                  color: "#fff",
                  fontWeight: 600,
                  cursor: "pointer",
                }}
              >
                {confirmSubmitting ? "Confirming..." : "Confirm Trip Completed"}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ── Follow-up Call Modal ────────────────────────────────────────── */}
      {followUpRide && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(0,0,0,0.45)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 1000,
            padding: 16,
          }}
          onClick={closeFollowUpModal}
        >
          <div
            style={{
              background: "#fff",
              borderRadius: 10,
              padding: 24,
              width: "100%",
              maxWidth: 460,
              maxHeight: "90vh",
              overflowY: "auto",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <h3 style={{ margin: "0 0 4px" }}>Post-Ride Follow-up Call</h3>
            <p style={{ margin: "0 0 16px", color: "#888", fontSize: 13 }}>
              {followUpRide.rideId} ·{" "}
              {followUpRide.passenger?.name || "Passenger"}
              {followUpRide.passenger?.phone
                ? ` · ${followUpRide?.passenger?.phone || followUpRide.passenger?.mobile}`
                : ""}
            </p>
          

            {/* Reached safely */}
            <FollowUpQuestion
              label="Did the passenger reach safely?"
              value={reachedSafely}
              onChange={setReachedSafely}
            />

            {/* App useful */}
            <FollowUpQuestion
              label="Was the Moovuruli app useful for them?"
              value={appUseful}
              onChange={setAppUseful}
            />

            {/* Any issue */}
            <FollowUpQuestion
              label="Any issue or problem with the ride / driver?"
              value={hasIssue}
              onChange={setHasIssue}
            />

            {hasIssue && (
              <div style={{ marginTop: 4, marginBottom: 14 }}>
                <textarea
                  placeholder="What issue did the passenger mention?"
                  value={issueDetails}
                  onChange={(e) => setIssueDetails(e.target.value)}
                  rows={3}
                  style={{
                    width: "100%",
                    borderRadius: 6,
                    border: "1px solid #ddd",
                    padding: 8,
                    fontSize: 13,
                    resize: "vertical",
                    marginBottom: 12,
                  }}
                />
                <FollowUpQuestion
                  label="Did the driver still bring them / handle it safely?"
                  value={driverBroughtSafely}
                  onChange={setDriverBroughtSafely}
                />
              </div>
            )}

            {/* Notes */}
            <div style={{ marginTop: 8, marginBottom: 16 }}>
              <label
                style={{
                  fontSize: 13,
                  color: "#555",
                  display: "block",
                  marginBottom: 6,
                }}
              >
                Additional notes (optional)
              </label>
              <textarea
                placeholder="Anything else worth recording..."
                value={followUpNotes}
                onChange={(e) => setFollowUpNotes(e.target.value)}
                rows={2}
                style={{
                  width: "100%",
                  borderRadius: 6,
                  border: "1px solid #ddd",
                  padding: 8,
                  fontSize: 13,
                  resize: "vertical",
                }}
              />
            </div>

            {followUpError && (
              <p style={{ color: "#A32D2D", fontSize: 13, marginBottom: 12 }}>
                {followUpError}
              </p>
            )}

            <div
              style={{ display: "flex", justifyContent: "flex-end", gap: 10 }}
            >
              <button
                onClick={closeFollowUpModal}
                style={{
                  background: "none",
                  border: "1px solid #ddd",
                  borderRadius: 6,
                  padding: "8px 16px",
                  fontSize: 13,
                  cursor: "pointer",
                }}
              >
                Cancel
              </button>
              <button
                onClick={handleSubmitFollowUp}
                disabled={followUpSubmitting}
                style={{
                  background: "#0F6E56",
                  color: "#fff",
                  border: "none",
                  borderRadius: 6,
                  padding: "8px 16px",
                  fontSize: 13,
                  cursor: "pointer",
                }}
              >
                {followUpSubmitting ? "Saving..." : "Save"}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

// ── Small Yes/No question row used inside the Follow-up Call modal ────────
function FollowUpQuestion({ label, value, onChange }) {
  return (
    <div style={{ marginBottom: 14 }}>
      <label
        style={{
          fontSize: 13,
          color: "#555",
          display: "block",
          marginBottom: 6,
        }}
      >
        {label}
      </label>
      <div style={{ display: "flex", gap: 8 }}>
        <button
          type="button"
          onClick={() => onChange(true)}
          style={{
            flex: 1,
            padding: "6px 0",
            borderRadius: 6,
            border: value === true ? "1px solid #0F6E56" : "1px solid #ddd",
            background: value === true ? "#0F6E56" : "#fff",
            color: value === true ? "#fff" : "#333",
            fontSize: 13,
            cursor: "pointer",
          }}
        >
          Yes
        </button>
        <button
          type="button"
          onClick={() => onChange(false)}
          style={{
            flex: 1,
            padding: "6px 0",
            borderRadius: 6,
            border: value === false ? "1px solid #A32D2D" : "1px solid #ddd",
            background: value === false ? "#A32D2D" : "#fff",
            color: value === false ? "#fff" : "#333",
            fontSize: 13,
            cursor: "pointer",
          }}
        >
          No
        </button>
      </div>
    </div>
  );
}